import axios from 'axios';
import apiService from '../apiService';

export default async function addGuestToFaceDetection(
  detectionId = '',
  eventId = '',
  system = '',
  guestId = '',
) {
  try {
    let _request = {
      url: `${apiService.getUrl().faceRecognition}faceDetection/addGuestToFaceDetection`,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        detectionId: detectionId,
        eventId: eventId,
        system: system,
        guestId: guestId,
      }
    }
    const _ret = await axios(_request);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return _ret.data.data;
  } catch (error) {
    console.log('Error addGuestToFaceDetection', error);
    throw error;
  }
}
